import { atom } from "recoil";
import { Route } from "routes/routes";

export const routesForBreadcrumbAtom = atom<Omit<Route, "subRoutes">[] | undefined>({
  key: "routesForBreadcrumbAtom",
  default: undefined,
});
